<template>
  <div class="device-list-bd">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{ 'mr-0': false }"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input
            :placeholder="$t('crm_deviceList.he_tong_bian_hao')"
            v-model="formSearch.search"
            clearable
            @keyup.enter.native="onPageChange({ page: 1 })"
            style="width: 280px"
          >
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 产品型号 -->
        <el-form-item :label="$t('crm_deviceList.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            placeholder=""
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 生效日期 -->
        <el-form-item :label="$t('crm_deviceList.sheng_xiao_ri_qi')">
          <custom-date-picker
            v-model="formSearch.effectiveDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 启租日期 => 开始日期 -->
        <el-form-item :label="$t('crm_deviceList.kai_shi_ri_qi')">
          <custom-date-picker
            v-model="formSearch.rentalTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 到期日期 -->
        <el-form-item :label="$t('crm_deviceList.dao_qi_ri_qi')">
          <custom-date-picker
            v-model="formSearch.backTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 机身号 -->
        <el-form-item :label="$t('crm_deviceList.ji_shen_hao')">
          <el-input
            v-model="formSearch.bodyNum"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 甲方授权代表 -->
        <el-form-item :label="$t('crm_deviceList.jfsqdb')">
          <el-input
            v-model="formSearch.partAName"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 乙方 -->
        <el-form-item :label="$t('crm_deviceList.yi_fang')">
          <el-input
            v-model="formSearch.customerName"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 售后 -->
        <el-form-item :label="$t('crm_deviceList.shou_hou')">
          <el-input
            v-model="formSearch.afterServiceName"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 业务负责人 -->
        <el-form-item :label="$t('crm_deviceList.ye_wu_fu_ze_ren')">
          <el-input
            v-model="formSearch.salesman"
            style="width: 100%"
          ></el-input>
        </el-form-item>

      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        height="100%"
        type="radio"
        tableCode="crm_try_contract_devices"
        v-loading="isLoading"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        :slots="['contractNo', 'nextContractNo', 'customContractNo', 'locationNameAndSiteName']"
        @filter="filterChange"
        @column="setColumn"
        columnRef="column"
        @sort="sortChange"
      >
        <template v-slot:locationNameAndSiteName="scope">
          {{getLocationNameAndSiteName(scope.row) || '-'}}
        </template>
        <template v-slot:contractNo="scope">
          <div
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path, billType: 15 })"
          >
            {{ scope.row.contractNo }}
          </div>
        </template>
        <template v-slot:nextContractNo="scope">
          <div
            v-if="scope.row.nextContractNo"
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.nextOrderId, contractClass: scope.row.nextOrderType, parentPath: $route.path, billType: 15 })"
          >
            {{ scope.row.nextContractNo }}
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:customContractNo="scope">
          <div
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path, billType: 15 })"
          >
            {{ scope.row.customContractNo }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';
// import contractRule from '@/utils/contractRule.js';
import moment from 'moment';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';

export default {
  name: 'contractManagement',
  props: {
    contractTypeData: {
      type: Array,
      default() {
        return [];
      },
    }, // 合同类型
    value: [String, Number],
    contractType: [String, Number],
  },
  components: {
  },
  mixins: [resetFormSearchMixins, tableFilterValueGetParamMixins],
  data() {
    return {
      // tableCode: 'contract_list',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractState: '',
        // contractType: ['20'],
        // bizClass: '20'
        // 高级搜索:
        // 产品型号
        productCode: '',
        // 生效日期（区间）
        effectiveDate: null,
        // 启租日期（区间）
        rentalTime: null,
        // 到期日期（区间）
        backTime: null,
        // 租金
        unitPrice: '',
        // 机身号
        bodyNum: '',
        // 甲方授权代表
        partAName: '',
        // 乙方
        customerName: '',
        // 售后
        afterServiceName: '',
        // 业务负责人
        salesman: '',

      },
      // 更多筛选
      searchFilters: false,
      totalRows: null,
      isLoading: false,
      tableList: [],
      // 操作

      // 审批
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      // 退回
      dialogVisible2: false,
      dialogModel2: {},
      dialogData2: {},
      // 发送电子合同 确认签署
      dialogVisible3: false,
      dialogModel3: {},
      dialogData3: {},

      //  租赁确认单
      dialogVisible5: false,
      dialogModel5: {},
      //  合同操作
      dialogVisible6: false,
      dialogModel6: {},
      //  修改业务负责人
      dialogVisible7: false,
      dialogModel7: {},

      // 用户身份
      // userInfo: {},
      // 操作
      visibleSet: '',
      dialogSetData: {},
      link: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  mounted() {
    this.formSearch.effectiveDate = [this.$momentWorld(moment().startOf('month')), this.$momentWorld(moment().endOf('day'))];
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });


    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.userInfo = this.$store.state.userInfo;

    this.getTableList();
  },
  // activated() {
  //   this.getContract();
  //   // this.userInfo = this.$store.state.userInfo;
  // },
  methods: {
    getTableList() {
      this.isLoading = true;
      const reqData = this.getReqData();

      this.$getJSON(apis.orderDeviceTrialPage, reqData).then((res) => {
        this.totalRows = res.data.total;
        this.tableList = res.data.list || [];
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getReqData() {
      const ret = {
        ...this.formSearch,
        loadRes: this.$route.path,
      };

      // 生效日期
      if (ret.effectiveDate && ret.effectiveDate.length) {
        ret.effectiveStartDate = ret.effectiveDate[0];
        ret.effectiveEndDate = ret.effectiveDate[1];
        delete ret.effectiveDate;
      }

      // 启租日期
      if (ret.rentalTime && ret.rentalTime.length) {
        ret.rentalStartTime = ret.rentalTime[0];
        ret.rentalEndTime = ret.rentalTime[1];
        delete ret.rentalTime;
      }

      // 到期日期
      if (ret.backTime && ret.backTime.length) {
        ret.backStartTime = ret.backTime[0];
        ret.backEndTime = ret.backTime[1];
        delete ret.backTime;
      }


      return ret;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

    exportTable() {
      const reqData = this.getReqData();
      delete reqData.pageSize;
      delete reqData.pageNum;

      this.$exportFlie(apis.orderDeviceTrialExport, reqData);

    }
  },
};
</script>

<style lang="scss" scoped>
.device-list-bd {
  padding-left: 16px;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
}
</style>
